import axios from "axios";
import { Loading, Message } from "element-ui";
import router from "../router/index.js";
import { getCookie, delCookie } from "@/utils/cookie.js";
import { tokenName, baseUrl } from "../config/project";
import lang from '../lang/index.js'
import DonMessage from '@/utils/msg.js'
let messageInstance  = null
let loading;
let timer = null
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中....",
    background: "rgba(0, 0, 0, 0.7)",
  });
}

function endLoading() {
  if (loading) {
    loading.close();
  }
}
//超时2分钟
// console.log(axios.defaults)
axios.defaults.timeout = 1000 * 60 * 2;
axios.defaults.baseURL = baseUrl;
// 请求拦截
axios.interceptors.request.use(
  (confing) => {
    // let token = JSON.parse(localStorage.getItem("token"));
    let token;
    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token")
    }

    //设置请求头
    if (token) {
      // config.headers["x-auth-token"] = token
      confing.headers.Authorization = "Bearer " + token;
      // confing.headers.Authorization = token;
    }
    // confing.headers.contentType = ;
    return confing;
  },
  (error) => {
    Message.error("服务异常！");
    endLoading();
    return Promise.reject(error);
  }
);

//响应拦截
axios.interceptors.response.use(
  (response) => {
    endLoading();
    //当返回信息为未登录或者登录失效的时候重定向为登录页面
    // if(response.data.code == 'W_100004' || response.data.message == '用户未登录或登录超时，请登录！'){
    //   router.push({
    //     path:"/",
    //     querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
    //   })
    // }
    // 获取状态码
    const { code } = response.data;
    if (code === 401) {
      if(messageInstance){
        Message.closeAll();
      }
      messageInstance = Message({
        type: 'error',
        message: lang.t("public.401"),
        onClose: ()=>{
          messageInstance = null
        }
      });
      //清除token
      delCookie("token");
      delCookie("userMessObj");
      //跳转到登录页面
      router.push("/login");
    }
    if (response.data.code != 200 && response.code === 1) {
      // console.log(response.data.metadata.msg, "000");
      // console.log(code, "code")
      Message.error(
        response.data.metadata.msg ||
          response.data.msg ||
          response.data.message ||
          response.data
      );
      // MSG.error()
      return false;
    } else if(code && code !== 200 && code !== 401){
      Message.error(
        // response.data.msg || response.data.message
        lang.t(`public.${code}`)
    );
    } else {
      return response.data;
    }
  },
  (error) => {
    // console.log(error, "error");
    Message.error(
      error.response
        ? error.response.data.metadata
          ? error.response.data.msg
          : error.response.data.msg
        : "Network Error"
    );
    if (error.response.data.code == 401 || error.response.data.code == 402) {
      endLoading();
      delCookie("token");
      delCookie("userMessObj");
      //跳转到登录页面
      router.push("/login");
    }
    return Promise.reject(error);
    // return error.response.data
  }
);
export default axios;
